import { defineComponent as f, openBlock as u, createBlock as p, withCtx as o, createTextVNode as g, toDisplayString as c, unref as l, computed as z, createElementBlock as A, Fragment as G, createVNode as r, createElementVNode as h, inject as M, createCommentVNode as x, mergeProps as D, renderSlot as R, normalizeProps as J, guardReactiveProps as q, createSlots as K, resolveDynamicComponent as Q, normalizeClass as $, useSlots as ee, onMounted as V, onUnmounted as Y, withKeys as P, ref as te } from "vue";
import { useI18n as y } from "vue-i18n";
import { VCardText as B, VCardTitle as E, VCardSubtitle as O, VCardActions as j, VCard as T } from "vuetify/lib/components/VCard/index.mjs";
import { useRoute as ne } from "vue-router";
import { VImg as oe } from "vuetify/lib/components/VImg/index.mjs";
import { VList as N, VListItem as U } from "vuetify/lib/components/VList/index.mjs";
import { VBtn as w } from "vuetify/lib/components/VBtn/index.mjs";
import { VDivider as L } from "vuetify/lib/components/VDivider/index.mjs";
import { VSpacer as _, VRow as re, VCol as H } from "vuetify/lib/components/VGrid/index.mjs";
import { VAvatar as ae } from "vuetify/lib/components/VAvatar/index.mjs";
import { VIcon as S } from "vuetify/lib/components/VIcon/index.mjs";
import { VMenu as ie } from "vuetify/lib/components/VMenu/index.mjs";
import { VBtn as le } from "vuetify/components";
import { VDialog as W } from "vuetify/lib/components/VDialog/index.mjs";
const n = Object.freeze({
  brandColor: {
    base: "#007E94",
    dark: "#006A83",
    light: "#48ABBE",
    xdark: "#00586C",
    xlight: "#91D1DF",
    xxdark: "#00404E",
    xxlight: "#D9F1F6"
  },
  colorsForAttention: {
    alert: {
      base: "#FFD600",
      dark: "#E1B800",
      light: "#FFE77B",
      xdark: "#C49B00",
      xlight: "#FFEFA7",
      xxdark: "#B38800",
      xxlight: "#FFFAD9"
    },
    danger: {
      base: "#FF493A",
      dark: "#E84234",
      light: "#FF8178",
      xdark: "#CF3B2F",
      xlight: "#FFB8B3",
      xxdark: "#B53329",
      xxlight: "#FFE3E1"
    },
    success: {
      base: "#57D48A",
      dark: "#4FBF7C",
      light: "#8FE3B1",
      xdark: "#42A268",
      xlight: "#B1EDC8",
      xxdark: "#357F52",
      xxlight: "#E6FAEC"
    }
  },
  greyScale: {
    base: "#BDBDBD",
    black: "#000000",
    dark: "#A1A1A1",
    light: "#E5E5E5",
    white: "#FFFFFF",
    xdark: "#808080",
    xlight: "#F0F0F0",
    xxdark: "#484848",
    xxlight: "#F8F8F8",
    xxxdark: "#262626"
  },
  products: {
    hdguard: "#143B6F",
    inis: "#B61E30",
    mdm: "#BACf00",
    winschool: "#63316D",
    xinis: "#E83452",
    xschool: "#793B8C"
  },
  secondaryAndComplement: {
    anemone: {
      base: "#FF3B74",
      dark: "#E83568",
      light: "#FF709A",
      xdark: "#CF2F5C",
      xlight: "#FFA6BF",
      xxdark: "#B52952",
      xxlight: "#FFD9E4"
    },
    aqua: {
      base: "#46C9FF",
      dark: "#3FB5E7",
      light: "#82D9FF",
      xdark: "#39A1CE",
      xlight: "#B8E9FF",
      xxdark: "#2C7DA1",
      xxlight: "#DBF4FF"
    },
    mermaid: {
      base: "#26D5BE",
      dark: "#1FBFAA",
      light: "#64E1D0",
      xdark: "#19A895",
      xlight: "#A1EDE3",
      xxdark: "#128072",
      xxlight: "#DFF9F5"
    },
    squid: {
      base: "#7066FF",
      dark: "#655CE9",
      light: "#8D8DFF",
      xdark: "#5A52CF",
      xlight: "#C6C3FF",
      xxdark: "#4E48B5",
      xxlight: "#E3E1FF"
    },
    starfish: {
      base: "#FF7E00",
      dark: "#E16F00",
      light: "#FFA556",
      xdark: "#C46100",
      xlight: "#FFBF87",
      xxdark: "#A65200",
      xxlight: "#FFE6D0"
    }
  }
}), se = {
  defaultTheme: "light",
  options: {
    customProperties: !0
  },
  themes: {
    light: {
      colors: {
        accent: n.secondaryAndComplement.starfish.base,
        // Accent color
        "alert-base": n.secondaryAndComplement.starfish.base,
        "alert-dark": n.colorsForAttention.alert.dark,
        "alert-light": n.colorsForAttention.alert.light,
        "alert-xdark": n.colorsForAttention.alert.xdark,
        "alert-xlight": n.colorsForAttention.alert.xlight,
        "alert-xxdark": n.colorsForAttention.alert.xxdark,
        "alert-xxlight": n.colorsForAttention.alert.xxlight,
        background: n.greyScale.xxlight,
        // primary background
        "blue-base": n.secondaryAndComplement.aqua.base,
        "blue-dark": n.secondaryAndComplement.aqua.dark,
        "blue-light": n.secondaryAndComplement.aqua.light,
        "blue-xdark": n.secondaryAndComplement.aqua.xdark,
        "blue-xlight": n.secondaryAndComplement.aqua.xlight,
        "blue-xxdark": n.secondaryAndComplement.aqua.xxdark,
        "blue-xxlight": n.secondaryAndComplement.aqua.xxlight,
        error: n.colorsForAttention.danger.xxdark,
        // Danger/Error color
        "error-base": n.colorsForAttention.danger.base,
        "error-dark": n.colorsForAttention.danger.dark,
        "error-light": n.colorsForAttention.danger.light,
        "error-xdark": n.colorsForAttention.danger.xdark,
        "error-xlight": n.colorsForAttention.danger.xlight,
        "error-xxdark": n.colorsForAttention.danger.xxdark,
        "error-xxlight": n.colorsForAttention.danger.xxlight,
        errorBackground: n.colorsForAttention.danger.xxlight,
        // Danger/Error background
        "greyScale-base": n.greyScale.base,
        "greyScale-black": n.greyScale.black,
        "greyScale-dark": n.greyScale.dark,
        "greyScale-light": n.greyScale.light,
        "greyScale-white": n.greyScale.white,
        "greyScale-xdark": n.greyScale.xdark,
        "greyScale-xlight": n.greyScale.xlight,
        "greyScale-xxdark": n.greyScale.xxdark,
        "greyScale-xxlight": n.greyScale.xxlight,
        "greyScale-xxxdark": n.greyScale.xxxdark,
        info: n.secondaryAndComplement.aqua.xxdark,
        // Info color
        infoBackground: n.secondaryAndComplement.aqua.xxlight,
        // Info background
        "mermaid-base": n.secondaryAndComplement.mermaid.base,
        "mermaid-dark": n.secondaryAndComplement.mermaid.dark,
        "mermaid-light": n.secondaryAndComplement.mermaid.light,
        "mermaid-xdark": n.secondaryAndComplement.mermaid.xdark,
        "mermaid-xlight": n.secondaryAndComplement.mermaid.xlight,
        "mermaid-xxdark": n.secondaryAndComplement.mermaid.xxdark,
        "mermaid-xxlight": n.secondaryAndComplement.mermaid.xxlight,
        "on-background": n.greyScale.xxxdark,
        "on-error": n.greyScale.white,
        "on-info": n.greyScale.white,
        "on-primary": n.greyScale.white,
        "on-secondary": n.greyScale.xxxdark,
        "on-success": n.greyScale.white,
        "on-surface": n.greyScale.xxxdark,
        "on-warning": n.greyScale.xxxdark,
        "pink-base": n.secondaryAndComplement.anemone.base,
        "pink-dark": n.secondaryAndComplement.anemone.dark,
        "pink-light": n.secondaryAndComplement.anemone.light,
        "pink-xdark": n.secondaryAndComplement.anemone.xdark,
        "pink-xlight": n.secondaryAndComplement.anemone.xlight,
        "pink-xxdark": n.secondaryAndComplement.anemone.xxdark,
        "pink-xxlight": n.secondaryAndComplement.anemone.xxlight,
        primary: n.brandColor.base,
        // Main color
        "primary-base": n.brandColor.base,
        "primary-dark": n.brandColor.dark,
        "primary-light": n.brandColor.light,
        "primary-xdark": n.brandColor.xdark,
        "primary-xlight": n.brandColor.xlight,
        "primary-xxdark": n.brandColor.xxdark,
        "primary-xxlight": n.brandColor.xxlight,
        "product-hdguard": n.products.hdguard,
        // HDGAURD (alt)
        "product-inis": n.products.inis,
        // INiS (alt)
        "product-mdm": n.products.mdm,
        // MDM
        "product-winschool": n.products.winschool,
        // winSCHOOL (alt)
        "product-xinis": n.products.xinis,
        // XINiS (alt)
        "product-xschool": n.products.xschool,
        // XSCHOOL (alt)
        "purple-base": n.secondaryAndComplement.squid.base,
        "purple-dark": n.secondaryAndComplement.squid.dark,
        "purple-light": n.secondaryAndComplement.squid.light,
        "purple-xdark": n.secondaryAndComplement.squid.xdark,
        "purple-xlight": n.secondaryAndComplement.squid.xlight,
        "purple-xxdark": n.secondaryAndComplement.squid.xxdark,
        "purple-xxlight": n.secondaryAndComplement.squid.xxlight,
        secondary: n.secondaryAndComplement.aqua.xdark,
        // Secondary color
        success: n.colorsForAttention.success.xxdark,
        // Success color
        "success-base": n.colorsForAttention.success.base,
        "success-dark": n.colorsForAttention.success.dark,
        "success-light": n.colorsForAttention.success.light,
        "success-xdark": n.colorsForAttention.success.xdark,
        "success-xlight": n.colorsForAttention.success.xlight,
        "success-xxdark": n.colorsForAttention.success.xxdark,
        "success-xxlight": n.colorsForAttention.success.xxlight,
        successBackground: n.colorsForAttention.success.xxlight,
        // Success background
        surface: n.greyScale.white,
        textColor: n.greyScale.xxxdark,
        // main text color
        warning: n.colorsForAttention.alert.xxdark,
        // Alert/Warning color
        "warning-base": n.secondaryAndComplement.starfish.base,
        "warning-dark": n.secondaryAndComplement.starfish.dark,
        "warning-light": n.secondaryAndComplement.starfish.light,
        "warning-xdark": n.secondaryAndComplement.starfish.xdark,
        "warning-xlight": n.secondaryAndComplement.starfish.xlight,
        "warning-xxdark": n.secondaryAndComplement.starfish.xxdark,
        "warning-xxlight": n.secondaryAndComplement.starfish.xxlight,
        warningBackground: n.colorsForAttention.alert.xxlight
        // Alert/Warning background
      }
    }
  }
}, Z = Symbol(), ce = {
  "content-header": {
    "logout-btn": (t) => {
      const { normalize: e } = t;
      return e(["Abmelden"]);
    }
  },
  "not-found": {
    oops: (t) => {
      const { normalize: e } = t;
      return e(["Oops..."]);
    },
    "page-not-exists": (t) => {
      const { normalize: e } = t;
      return e(["Diese Seite existiert nicht"]);
    },
    "gone-wrong-sorry": (t) => {
      const { normalize: e } = t;
      return e(["Hier ist wohl etwas schief gelaufen. Das tut uns leid..."]);
    }
  },
  "common-dialog": {
    "confirm-btn-text": (t) => {
      const { normalize: e } = t;
      return e(["OK"]);
    },
    text: (t) => {
      const { normalize: e } = t;
      return e(["Text."]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["Dialog"]);
    }
  },
  "error-dialog": {
    title: (t) => {
      const { normalize: e } = t;
      return e(["Fehler"]);
    },
    text: (t) => {
      const { normalize: e } = t;
      return e(["Es ist ein Fehler aufgetreten."]);
    },
    "confirm-btn-text": (t) => {
      const { normalize: e } = t;
      return e(["OK"]);
    },
    "copy-btn-text": (t) => {
      const { normalize: e } = t;
      return e(["Meldung in Zwischenablage kopieren"]);
    }
  },
  logincard: {
    title: (t) => {
      const { normalize: e } = t;
      return e(["Anmelden"]);
    },
    subtitle: (t) => {
      const { normalize: e } = t;
      return e(["Bitte wählen Sie aus, wie Sie sich anmelden möchten."]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Anmelden"]);
    },
    schoolid: {
      title: (t) => {
        const { normalize: e } = t;
        return e(["Anmeldung mit SchulID."]);
      },
      subtitle: (t) => {
        const { normalize: e } = t;
        return e(["SchulID ist ein Service von IST."]);
      }
    }
  },
  initpage: {
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e([]);
    },
    text: (t) => {
      const { normalize: e } = t;
      return e(["Erforderliche Informationen werden abgerufen."]);
    }
  },
  "checking-rights": {
    text: (t) => {
      const { normalize: e } = t;
      return e(["Rechte werden geprüft."]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e([]);
    }
  },
  "missing-person": {
    text: (t) => {
      const { normalize: e } = t;
      return e([`Für Ihre SchulID Anmeldung wurde keine Verknüpfung zu einer Organisation innerhalb der EduCloud gefunden.
Bitte wenden Sie sich damit an Ihre Organisation oder den Support der IST Deutschland GmbH.`]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["Fehlende EduCloud Verknüpfung"]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Fehlende EduCloud Verknüpfung"]);
    }
  },
  "missing-license": {
    text: (t) => {
      const { normalize: e } = t;
      return e([`Die ausgewählte Organisation hat keine Lizenz für das aktuelle Produkt.
Bitte wenden Sie sich damit an Ihre Organisation oder den Support der IST Deutschland GmbH.`]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["Lizenzfehler"]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Fehlende Produktlizenz"]);
    }
  },
  "missing-rights": {
    title: (t) => {
      const { normalize: e } = t;
      return e(["Ihnen fehlen die Rechte um auf diese Seite zugreifen zu dürfen."]);
    },
    subTitle: (t) => {
      const { normalize: e } = t;
      return e(["Bitte wenden Sie sich damit an den Administrator Ihrer Organisation."]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Fehlende Rechte"]);
    }
  }
}, de = {
  "content-header": {
    "logout-btn": (t) => {
      const { normalize: e } = t;
      return e(["Logout"]);
    }
  },
  "not-found": {
    oops: (t) => {
      const { normalize: e } = t;
      return e(["Oops..."]);
    },
    "page-not-exists": (t) => {
      const { normalize: e } = t;
      return e(["This page not exists"]);
    },
    "gone-wrong-sorry": (t) => {
      const { normalize: e } = t;
      return e(["Something must have gone wrong here. We are sorry about that..."]);
    }
  },
  "common-dialog": {
    "confirm-btn-text": (t) => {
      const { normalize: e } = t;
      return e(["OK"]);
    },
    text: (t) => {
      const { normalize: e } = t;
      return e(["Text."]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["Dialog"]);
    }
  },
  "error-dialog": {
    "copy-btn-text": (t) => {
      const { normalize: e } = t;
      return e(["Copy to clipboard"]);
    },
    "confirm-btn-text": (t) => {
      const { normalize: e } = t;
      return e(["OK"]);
    },
    text: (t) => {
      const { normalize: e } = t;
      return e(["An error occured."]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["Error"]);
    }
  },
  logincard: {
    title: (t) => {
      const { normalize: e } = t;
      return e(["Login"]);
    },
    subtitle: (t) => {
      const { normalize: e } = t;
      return e(["Please choose how you want to login."]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Login"]);
    },
    schoolid: {
      title: (t) => {
        const { normalize: e } = t;
        return e(["Login with SchulID."]);
      },
      subtitle: (t) => {
        const { normalize: e } = t;
        return e(["SchulID is a service from IST."]);
      }
    }
  },
  initpage: {
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e([]);
    },
    text: (t) => {
      const { normalize: e } = t;
      return e(["Required information will be retrieved."]);
    }
  },
  "checking-rights": {
    text: (t) => {
      const { normalize: e } = t;
      return e(["Rights are checked."]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e([]);
    }
  },
  "missing-person": {
    text: (t) => {
      const { normalize: e } = t;
      return e([`No link to an organization within EduCloud was found for your SchulID registration.
Please contact your organization or IST Deutschland GmbH support.`]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["Missing EduCloud link"]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Missing EduCloud link"]);
    }
  },
  "missing-license": {
    text: (t) => {
      const { normalize: e } = t;
      return e([`The selected organization does not have a license for the current product.
Please contact your organization or IST Deutschland GmbH support.`]);
    },
    title: (t) => {
      const { normalize: e } = t;
      return e(["License error"]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Missing product license"]);
    }
  },
  "missing-rights": {
    title: (t) => {
      const { normalize: e } = t;
      return e(["You lack the rights to access this page."]);
    },
    subTitle: (t) => {
      const { normalize: e } = t;
      return e(["Please contact the administrator of your organization with this."]);
    },
    viewtitle: (t) => {
      const { normalize: e } = t;
      return e(["Missing rights"]);
    }
  }
}, et = {
  de: ce,
  en: de
}, ue = /* @__PURE__ */ f({
  __name: "CheckingRights",
  setup(t, { expose: e }) {
    const { t: i } = y();
    return e({
      loading: !0,
      title: "checking-rights.viewtitle"
    }), (s, d) => (u(), p(B, null, {
      default: o(() => [
        g(c(l(i)("checking-rights.text")), 1)
      ]),
      _: 1
    }));
  }
}), me = /* @__PURE__ */ f({
  __name: "InitPage",
  setup(t, { expose: e }) {
    const { t: i } = y();
    return e({
      loading: !0,
      title: "initpage.viewtitle"
    }), (s, d) => (u(), p(B, null, {
      default: o(() => [
        g(c(l(i)("initpage.text")), 1)
      ]),
      _: 1
    }));
  }
}), ge = "data:image/png;base64,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", pe = /* @__PURE__ */ f({
  __name: "LoginCard",
  setup(t, { expose: e }) {
    const { t: i } = y(), s = ne(), d = z(
      () => "/login?returnUrl=" + encodeURIComponent(window.location.origin + s.fullPath)
    );
    return e({
      title: "logincard.viewtitle"
    }), (F, C) => (u(), A(G, null, [
      r(E, null, {
        default: o(() => [
          g(c(l(i)("logincard.title")), 1)
        ]),
        _: 1
      }),
      r(O, null, {
        default: o(() => [
          g(c(l(i)("logincard.subtitle")), 1)
        ]),
        _: 1
      }),
      r(B, null, {
        default: o(() => [
          r(N, null, {
            default: o(() => [
              r(U, {
                href: d.value,
                subtitle: l(i)("logincard.schoolid.subtitle"),
                title: l(i)("logincard.schoolid.title")
              }, {
                prepend: o(() => [
                  r(oe, {
                    class: "pr-4",
                    src: ge,
                    width: "128px"
                  })
                ]),
                _: 1
              }, 8, ["href", "subtitle", "title"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 64));
  }
}), he = /* @__PURE__ */ f({
  __name: "MissingLicense",
  setup(t, { expose: e }) {
    const { t: i } = y();
    return e({
      title: "missing-license.viewtitle"
    }), (s, d) => (u(), A(G, null, [
      r(E, null, {
        default: o(() => [
          g(c(l(i)("missing-license.title")), 1)
        ]),
        _: 1
      }),
      r(L),
      r(B, { class: "text-pre-wrap" }, {
        default: o(() => [
          g(c(l(i)("missing-license.text")), 1)
        ]),
        _: 1
      }),
      r(L),
      r(j, null, {
        default: o(() => [
          r(_),
          r(w, {
            href: "https://www.ist.com/de/service-support/",
            "prepend-icon": "mdi-headset",
            target: "blank"
          }, {
            default: o(() => [
              g("Support")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 64));
  }
}), xe = /* @__PURE__ */ f({
  __name: "MissingPerson",
  setup(t, { expose: e }) {
    const { t: i } = y();
    return e({
      title: "missing-person.viewtitle"
    }), (s, d) => (u(), A(G, null, [
      r(E, null, {
        default: o(() => [
          g(c(l(i)("missing-person.title")), 1)
        ]),
        _: 1
      }),
      r(L),
      r(B, { class: "text-pre-wrap" }, {
        default: o(() => [
          g(c(l(i)("missing-person.text")), 1)
        ]),
        _: 1
      }),
      r(L),
      r(j, null, {
        default: o(() => [
          r(_),
          r(w, {
            href: "https://www.ist.com/de/service-support/",
            "prepend-icon": "mdi-headset",
            target: "blank"
          }, {
            default: o(() => [
              g("Support")
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ], 64));
  }
}), fe = { class: "text-h6" }, ke = { class: "text-subtitle-2" }, Ae = /* @__PURE__ */ f({
  __name: "MissingRights",
  setup(t, { expose: e }) {
    const { t: i } = y();
    return e({
      title: "missing-rights.viewtitle"
    }), (s, d) => (u(), p(B, null, {
      default: o(() => [
        h("p", fe, c(l(i)("missing-rights.title")), 1),
        h("p", ke, c(l(i)("missing-rights.subTitle")), 1)
      ]),
      _: 1
    }));
  }
}), ye = Symbol(), Fe = { class: "content-header d-flex flex-row" }, be = { class: "d-flex flex-column justify-center" }, ze = { class: "d-flex" }, we = {
  key: 0,
  class: "backlink pl-4"
}, Be = { class: "header-title d-flex pl-4" }, ve = {
  key: 0,
  class: "d-flex"
}, Ce = {
  key: 0,
  class: "pr-4 orga-title"
}, Ie = /* @__PURE__ */ f({
  __name: "ContentHeader",
  props: {
    backTitle: { default: "Zurück" },
    backTitleLink: { default: void 0 },
    title: { default: "IST" }
  },
  emits: ["logout"],
  setup(t, { emit: e }) {
    const i = M(ye, () => ({
      firstName: "",
      lastName: "",
      orgaTitle: ""
    })), { firstName: s, lastName: d, orgaTitle: F } = i(), C = z(() => {
      if (b.value) {
        const m = l(s), k = l(d);
        return m.slice(0, 1) + k.slice(0, 1);
      }
    }), v = z(() => {
      if (b.value) {
        const m = l(s), k = l(d);
        return m + " " + k;
      }
    }), b = z(() => {
      const m = l(s), k = l(d);
      return !!(m && k && m.length > 0 && k.length > 0);
    });
    function a() {
      e("logout");
    }
    return (m, k) => (u(), A("div", Fe, [
      h("div", be, [
        h("div", ze, [
          m.backTitleLink ? (u(), A("div", we, [
            r(w, {
              class: "pa-0",
              color: "accent-darken4",
              to: m.backTitleLink,
              variant: "text"
            }, {
              prepend: o(() => [
                r(S, { color: "primary" }, {
                  default: o(() => [
                    g("mdi-arrow-left")
                  ]),
                  _: 1
                })
              ]),
              default: o(() => [
                h("span", null, c(m.$t(m.backTitle)), 1)
              ]),
              _: 1
            }, 8, ["to"])
          ])) : x("", !0)
        ]),
        h("div", Be, c(m.title && m.$t(m.title)), 1)
      ]),
      r(_),
      b.value ? (u(), A("div", ve, [
        r(ie, null, {
          activator: o(({ props: X }) => [
            r(w, D(X, {
              class: "mt-1 pl-2 pr-2",
              color: "primary mr-4",
              size: "x-large",
              title: v.value,
              variant: "text"
            }), {
              default: o(() => [
                l(F) ? (u(), A("span", Ce, c(l(F)), 1)) : x("", !0),
                r(ae, { color: "primary" }, {
                  default: o(() => [
                    h("span", null, c(C.value), 1)
                  ]),
                  _: 1
                })
              ]),
              _: 2
            }, 1040, ["title"])
          ]),
          default: o(() => [
            R(m.$slots, "default", { logout: a }, () => [
              r(N, { class: "pa-0" }, {
                default: o(() => [
                  r(U, {
                    "prepend-icon": "mdi-logout",
                    title: m.$t("content-header.logout-btn"),
                    onClick: a
                  }, null, 8, ["title"])
                ]),
                _: 1
              })
            ])
          ]),
          _: 3
        })
      ])) : x("", !0)
    ]));
  }
});
const Se = { class: "page-layout" }, Ee = {
  inheritAttrs: !1
}, Te = /* @__PURE__ */ f({
  ...Ee,
  __name: "PageLayout",
  props: {
    backTitle: {},
    backTitleLink: {},
    fabArea: { type: Boolean },
    onLogout: { type: Function },
    title: {}
  },
  setup(t) {
    const e = M(
      Z,
      () => !1
    );
    return (i, s) => (u(), A("div", Se, [
      r(Ie, J(q(i.$props)), K({ _: 2 }, [
        l(e)("ContentHeaderMenu") ? {
          name: "default",
          fn: o(() => [
            (u(), p(Q("ContentHeaderMenu")))
          ]),
          key: "0"
        } : void 0
      ]), 1040),
      h("div", {
        class: $(["content-body scroll-container pa-4", { "has-fab": i.fabArea }])
      }, [
        r(T, D({ class: "pa-4" }, i.$attrs), {
          default: o(() => [
            R(i.$slots, "default", {}, void 0, !0)
          ]),
          _: 3
        }, 16)
      ], 2)
    ]));
  }
});
const De = (t, e) => {
  const i = t.__vccOpts || t;
  for (const [s, d] of e)
    i[s] = d;
  return i;
}, Le = /* @__PURE__ */ De(Te, [["__scopeId", "data-v-ceb17697"]]), Re = { class: "h-100 d-flex justify-center align-center" }, je = {
  inheritAttrs: !1
}, _e = /* @__PURE__ */ f({
  ...je,
  __name: "SingleCardLayout",
  props: {
    backTitle: {},
    backTitleLink: {},
    fabArea: { type: Boolean },
    onLogout: { type: Function },
    title: {}
  },
  setup(t) {
    return (e, i) => (u(), p(Le, D({ class: "h-100" }, e.$props), {
      default: o(() => [
        h("div", Re, [
          r(T, D({ color: "primary" }, e.$attrs, {
            "max-width": "33%",
            variant: "outlined"
          }), {
            default: o(() => [
              R(e.$slots, "default")
            ]),
            _: 3
          }, 16)
        ])
      ]),
      _: 3
    }, 16));
  }
}), Ge = Symbol(), tt = /* @__PURE__ */ f({
  __name: "AccessButton",
  props: {
    accessRequirements: {},
    icon: { type: [Array, String, Boolean] }
  },
  setup(t) {
    const e = M(Ge, () => !0), i = ee();
    return (s, d) => l(e)(s.accessRequirements) ? (u(), p(l(le), {
      key: 0,
      icon: s.icon
    }, {
      default: o(() => [
        l(i).default ? R(s.$slots, "default", { key: 0 }) : x("", !0)
      ]),
      _: 3
    }, 8, ["icon"])) : x("", !0);
  }
}), nt = /* @__PURE__ */ f({
  __name: "CommonDialog",
  props: {
    title: { default: "common-dialog.title" },
    subTitle: { default: "" },
    text: { default: "common-dialog.text" },
    confirmBtnText: { default: "common-dialog.confirm-btn-text" },
    confirmBtnColor: { default: "primary" },
    confirmBtnIcon: { default: "" },
    cancelBtnText: { default: "" },
    cancelBtnColor: { default: "primary" },
    cancelBtnIcon: { default: "" },
    escapeLeave: { type: Boolean, default: !0 },
    persistent: { type: Boolean, default: !0 },
    width: { default: void 0 },
    modelValue: { type: Boolean, default: !1 }
  },
  emits: [
    "ConfirmBtnClicked",
    "CancelBtnClicked",
    "update:modelValue"
  ],
  setup(t, { emit: e }) {
    const i = t, { t: s } = y(), d = z({
      get() {
        return i.modelValue;
      },
      set(a) {
        e("update:modelValue", a);
      }
    });
    function F() {
      e("ConfirmBtnClicked");
    }
    function C() {
      e("CancelBtnClicked");
    }
    function v() {
      i.escapeLeave && e("CancelBtnClicked");
    }
    const b = (a) => {
      a.key === "Escape" && i.escapeLeave && v();
    };
    return V(() => {
      document.addEventListener("keydown", b);
    }), Y(() => {
      document.removeEventListener("keydown", b);
    }), (a, m) => (u(), p(W, {
      modelValue: d.value,
      "onUpdate:modelValue": m[0] || (m[0] = (k) => d.value = k),
      "max-width": a.width,
      persistent: a.persistent,
      width: "auto",
      onKeydown: P(v, ["esc"])
    }, {
      default: o(() => [
        r(T, null, {
          default: o(() => [
            r(E, null, {
              default: o(() => [
                g(c(l(s)(a.title)), 1)
              ]),
              _: 1
            }),
            a.subTitle ? (u(), p(O, { key: 0 }, {
              default: o(() => [
                g(c(l(s)(a.subTitle)), 1)
              ]),
              _: 1
            })) : x("", !0),
            r(B, { innerHTML: a.text }, null, 8, ["innerHTML"]),
            r(j, { class: "justify-end pa-4" }, {
              default: o(() => [
                r(w, {
                  color: a.confirmBtnColor,
                  variant: "flat",
                  onClick: F
                }, {
                  default: o(() => [
                    a.confirmBtnIcon ? (u(), p(S, {
                      key: 0,
                      class: "pr-2",
                      icon: a.confirmBtnIcon
                    }, null, 8, ["icon"])) : x("", !0),
                    g(c(l(s)(a.confirmBtnText)), 1)
                  ]),
                  _: 1
                }, 8, ["color"]),
                a.cancelBtnText ? (u(), p(w, {
                  key: 0,
                  class: "ml-2",
                  color: a.cancelBtnColor,
                  onClick: C
                }, {
                  default: o(() => [
                    a.cancelBtnIcon ? (u(), p(S, {
                      key: 0,
                      class: "pr-2",
                      icon: a.cancelBtnIcon
                    }, null, 8, ["icon"])) : x("", !0),
                    g(c(l(s)(a.cancelBtnText)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])) : x("", !0)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "max-width", "persistent", "onKeydown"]));
  }
}), Me = ["innerHTML"], Oe = {
  key: 0,
  class: "stack-trace"
}, ot = /* @__PURE__ */ f({
  __name: "ErrorDialog",
  props: {
    title: { default: "error-dialog.title" },
    subTitle: { default: "" },
    text: { default: "error-dialog.text" },
    showCopy: { type: Boolean, default: !1 },
    showStackTrace: { type: Boolean, default: !1 },
    copyButtonText: { default: "error-dialog.copy-btn-text" },
    copyButtonColor: { default: "primary" },
    copyButtonIcon: { default: "mdi-content-copy" },
    confirmBtnText: { default: "error-dialog.confirm-btn-text" },
    confirmBtnColor: { default: "primary" },
    confirmBtnIcon: { default: "" },
    escapeLeave: { type: Boolean, default: !0 },
    persistent: { type: Boolean, default: !0 },
    width: { default: void 0 },
    errorObject: { default: void 0 },
    modelValue: { type: Boolean, default: !1 }
  },
  emits: ["ConfirmBtnClicked", "update:modelValue"],
  setup(t, { emit: e }) {
    const i = t, { t: s } = y(), d = z({
      get() {
        return i.modelValue;
      },
      set(a) {
        e("update:modelValue", a);
      }
    });
    function F() {
      e("ConfirmBtnClicked");
    }
    function C() {
      var a = JSON.stringify(i.errorObject, null, 4);
      navigator.clipboard.writeText(a);
    }
    const v = (a) => {
      a.key === "Escape" && i.escapeLeave && F();
    };
    function b() {
      i.escapeLeave && e("ConfirmBtnClicked");
    }
    return V(() => {
      document.addEventListener("keydown", v);
    }), Y(() => {
      document.removeEventListener("keydown", v);
    }), (a, m) => (u(), p(W, {
      modelValue: d.value,
      "onUpdate:modelValue": m[0] || (m[0] = (k) => d.value = k),
      "max-width": a.width,
      persistent: a.persistent,
      width: "auto",
      onKeydown: P(b, ["esc"])
    }, {
      default: o(() => [
        r(T, null, {
          default: o(() => [
            r(E, { class: "d-flex" }, {
              default: o(() => [
                g(c(l(s)(a.title)) + " ", 1),
                r(_),
                a.showCopy ? (u(), p(w, {
                  key: 0,
                  color: a.copyButtonColor,
                  density: "comfortable",
                  icon: "",
                  title: l(s)(a.copyButtonText),
                  variant: "flat",
                  onClick: C
                }, {
                  default: o(() => [
                    r(S, null, {
                      default: o(() => [
                        g(c(a.copyButtonIcon), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["color", "title"])) : x("", !0)
              ]),
              _: 1
            }),
            a.subTitle ? (u(), p(O, { key: 0 }, {
              default: o(() => [
                g(c(l(s)(a.subTitle)), 1)
              ]),
              _: 1
            })) : x("", !0),
            r(B, null, {
              default: o(() => [
                h("div", {
                  innerHTML: l(s)(a.text)
                }, null, 8, Me),
                a.showStackTrace ? (u(), A("div", Oe, [
                  h("div", null, c(a.errorObject), 1)
                ])) : x("", !0)
              ]),
              _: 1
            }),
            r(j, { class: "justify-end pa-4" }, {
              default: o(() => [
                r(w, {
                  color: a.confirmBtnColor,
                  variant: "flat",
                  onClick: F
                }, {
                  default: o(() => [
                    a.confirmBtnIcon ? (u(), p(S, {
                      key: 0,
                      class: "pr-2",
                      icon: a.confirmBtnIcon
                    }, null, 8, ["icon"])) : x("", !0),
                    g(c(l(s)(a.confirmBtnText)), 1)
                  ]),
                  _: 1
                }, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue", "max-width", "persistent", "onKeydown"]));
  }
});
const rt = /* @__PURE__ */ f({
  __name: "NotFound",
  setup(t) {
    const { t: e } = y();
    return (i, s) => (u(), p(T, { class: "height-100" }, {
      default: o(() => [
        r(re, { class: "pt-8 pb-8" }, {
          default: o(() => [
            r(H, { cols: "4" }),
            r(H, { cols: "8" }, {
              default: o(() => [
                h("h1", null, [
                  r(S, { class: "mr-2" }, {
                    default: o(() => [
                      g(" mdi-emoticon-frown-outline ")
                    ]),
                    _: 1
                  }),
                  g(" " + c(l(e)("not-found.oops")), 1)
                ]),
                h("h3", null, c(l(e)("not-found.page-not-exists")), 1),
                h("p", null, c(l(e)("not-found.gone-wrong-sorry")), 1)
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }));
  }
}), at = () => {
  function t(e) {
    e.component("LoginView", I(pe)), e.component("InitPageView", I(me)), e.component("CheckingRightsView", I(ue)), e.component("MissingPersonView", I(xe)), e.component("MissingLicenseView", I(he)), e.component("MissingRightsView", I(Ae)), e.provide(Z, (i) => !!e.component(i));
  }
  return {
    install: t
  };
}, it = n, lt = se;
function I(t) {
  return {
    components: {
      CardContent: t,
      SingleCardLayout: _e
    },
    setup() {
      const e = te(), i = z(() => {
        var d;
        return (d = e.value) == null ? void 0 : d.title;
      }), s = z(() => {
        var d;
        return ((d = e.value) == null ? void 0 : d.loading) ?? !1;
      });
      return {
        content: e,
        loading: s,
        title: i
      };
    },
    template: `
		<single-card-layout :loading="loading" :title="title">
			<card-content ref="content"></card-content>
		</single-card-layout>
		`
  };
}
export {
  tt as AccessButton,
  nt as CommonDialog,
  Ie as ContentHeader,
  ot as ErrorDialog,
  rt as NotFound,
  Le as PageLayout,
  _e as SingleCardLayout,
  Ge as checkRequirementsInjectionKey,
  it as colorPalette,
  ye as contentHeaderPropsInjectionKey,
  at as createStyleComponents,
  lt as istThemeLight,
  et as messages
};
